import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';
import { ISiteDesign } from '@fi-shared/models';
import { AppTextService } from '@fi-shared/app-text';

enum SiteDesignSuccessorType {
    WithoutSuccessor = 0,
    SingleSuccessor = 1,
    MultiSuccessor = 2,
}

export interface ISiteDesignDeleteData {
    siteDesignToDeleteId: number;
    allSiteDesigns: ISiteDesign[];
}

export interface ISiteDesignDeleteResult {
    successorSiteDesignId: number;
    siteDesignIdToDelete: number;
}

@Component({
    selector: 'fi-site-design-brand-delete-confirm-dialog',
    template: `
        @if (successorType === SiteDesignSuccessorTypes.WithoutSuccessor) {
          {{ 'site_design.delete_brand_confirmation_message' | fiAppText }}
        }
        @if (successorType === SiteDesignSuccessorTypes.SingleSuccessor) {
          {{ getMessageForSingleAccessor() }}
        }
        @if (successorType === SiteDesignSuccessorTypes.MultiSuccessor) {
          <div>{{ 'site_design.delete_brand_select_new_brand' | fiAppText }}</div>
          <fi-select-search
            [(ngModel)]="successorSiteDesignId"
            [items]="availableSuccessorSiteDesigns"
            [label]="'site_design.new_brand' | fiAppText"
            >
          </fi-select-search>
        }
        `,
    styleUrls: ['./fi-site-design-brand-delete-confirm-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-site-design-brand-delete-confirm-dialog' },
    standalone: false,
})
export class FiSiteDesignBrandDeleteConfirmDialogComponent
    extends FiDialogsContentBase<ISiteDesignDeleteData, ISiteDesignDeleteResult>
    implements OnInit
{
    successorSiteDesignId: number;
    successorType = SiteDesignSuccessorType.WithoutSuccessor;
    availableSuccessorSiteDesigns: ISiteDesign[];

    SiteDesignSuccessorTypes = SiteDesignSuccessorType;
    private appTextService: AppTextService;

    ngOnInit(): void {
        this.appTextService = this.injector.get(AppTextService);
        this.availableSuccessorSiteDesigns = this.data.allSiteDesigns.filter(
            (siteDesign) => siteDesign.Id !== this.data.siteDesignToDeleteId,
        );

        const currentSiteDesign = this.data.allSiteDesigns.find(
            (siteDesign) => siteDesign.Id === this.data.siteDesignToDeleteId,
        );
        if (currentSiteDesign.BusinessAreaIds.length) {
            if (this.availableSuccessorSiteDesigns.length > 1) {
                this.successorType = SiteDesignSuccessorType.MultiSuccessor;
            } else {
                this.successorType = SiteDesignSuccessorType.SingleSuccessor;
                this.successorSiteDesignId = this.availableSuccessorSiteDesigns[0]?.Id;
            }
        }
    }

    getMessageForSingleAccessor() {
        return this.appTextService.get('site_design.delete_brand_confirmation_message_single_accessor', {
            '{siteDesignName}': this.availableSuccessorSiteDesigns[0]?.Name,
        });
    }

    isYesButtonDisabled(): boolean {
        return this.successorType !== SiteDesignSuccessorType.WithoutSuccessor && !this.successorSiteDesignId;
    }

    getResult() {
        return {
            siteDesignIdToDelete: this.data.siteDesignToDeleteId,
            successorSiteDesignId: this.successorSiteDesignId,
        };
    }
}
